/**
 * Created by Daniela on 11/10/2016.
 */
import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[gtin13]'
})
export class Gtin13MaskDirective {
    constructor(
        public model: NgControl
    ) {}

    @HostListener('ngModelChange') ngModelChange() {
        this.modelValue();
    }

    @HostListener('keydown.backspace') onKeyDownBackspace() {
        this.modelValue(true);
    }

    private modelValue(backspace?: boolean) {
        if (this.model) {
            var model: any = this.model;
            if(model.viewModel) {
                if (typeof model.viewModel === 'number') {
                    model.viewModel = model.viewModel.toString();
                }
                this.inputChange(model.viewModel, backspace);
            }
        }
    }

    private inputChange(model: any, backspace?: any) {
        if (model) {
            var newVal = model.replace(/\D/g, '');

            if(backspace) {
                if((newVal.length === 1) || (newVal.length === 7)){
                    newVal = newVal.substring(0, newVal.length - 1);
                }
            }

            if (newVal.length == 0) {
                newVal = '';
            } else if (newVal.length === 1) {
                newVal = newVal.replace(/(\d{1})/, "$1 ");
            } else if (newVal.length <= 6) {
                newVal = newVal.replace(/(\d{1})(\d{0,5})/, "$1 $2");
            } else if (newVal.length <= 13) {
                newVal = newVal.replace(/(\d{1})(\d{0,6})(\d{0,6})/, "$1 $2 $3");
            }

            this.model.valueAccessor.writeValue(newVal);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/gtin-13-mask.directive.ts
 **/